import script from "./RecDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecDialog.vue?vue&type=script&setup=true&lang=ts"

import "./RecDialog.vue?vue&type=style&index=0&id=524cd7a0&lang=scss"

const __exports__ = script;

export default __exports__